import React, { RefObject } from 'react';

import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';
import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import BonusBanner from '~/src/features/yandex-landing/BonusBanner';
import CarouselRow from '~/src/features/yandex-landing/CarouselRow';
import HeaderTextBlock from '~/src/features/yandex-landing/HeaderTextBlock';
import type { IStationSections } from '~/src/features/yandex-landing/types';

import * as ST from './styled';

interface IHeader {
    callbackRef: RefObject<HTMLDivElement>,
    stationLight: IEquipment,
    stationSections: IStationSections[],
    city: ICurrentCity,
}

const Header: React.FC<IHeader> = ({ callbackRef, stationLight, stationSections, city }) => {
    return (
        <ST.HeaderBackground>
            <ST.ContainerHead>
                <HeaderTextBlock/>
                <BonusBanner stationLight={stationLight} city={city}/>
                <CarouselRow catalogMimicFormRef={callbackRef} stationSections={stationSections}/>
            </ST.ContainerHead>
        </ST.HeaderBackground>
    );
};

export default Header;
